import importModal from './views/importModal.html'
class preWarnListCtrl {
    constructor($scope, $location, logger, httpRequest, Upload, $timeout, $uibModal) {
        // ^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$
        // var reg = /^([\d]+[\w\(\)]*)$/;
        // var reg = /(^(?![a-zA-Z\(\)]+$)(?!((?![\d]+$)[\d\(\)]+)$)[\da-zA-Z\(\)]{6,20}$)/;
        // 初始化表单数据
        $scope.resData = []
        httpRequest.get_qryAlarmList({ pointCategory: '' }).then((res) => {
            $scope.resData = res.data.value
        })

        // 按钮滑过
        $scope.dropdown_rowhover = function dropdown_rowhover(row, flag) {
            row.dropdownhover = flag
        }

        // 禁用
        $scope.toEnabled = function toEnabled(item, index) {
            httpRequest
                .get_modStatus({
                    pointCode: item.pointCode,
                    status: '0',
                })
                .then((res) => {
                    $scope.resData[index].status = '0'
                    logger.logSuccess('禁用成功！')
                })
        }

        // 启用
        $scope.toAbled = function toAbled(item, index) {
            httpRequest
                .get_modStatus({
                    pointCode: item.pointCode,
                    status: '1',
                })
                .then(() => {
                    $scope.resData[index].status = '1'
                    logger.logSuccess('启用成功！')
                })
        }

        // 设置
        $scope.toSettingPage = function toSettingPage(item) {
            //
            $location.path(`/system/settingcenter/preWarn/setting/${item.pointCode}`).replace()
        }
        // 模板下载
        $scope.downloadExcel = function (code) {
            window.open(`${host.etcloudBiApp}alarm/dlTaskService/export_${codeType(code)}?accessToken=${localStorage.getItem('id_token')}`)
        }
        $scope.uploadFiles = function (file, errFiles, code) {
            // 不符合文件格式的错误提示
            if (file == null && errFiles.length >= 1) {
                logger.logError('文件类型错误，文件大小不超过50MB，只支持.xlsx,.xls格式文件导入')
                return
            }
            if (file) {
                const data = {
                    importFile: file,
                }
                file.upload = Upload.upload({
                    url: `${host.etcloudBiApp}alarm/dlTaskService/import_${codeType(code)}`,
                    data,
                })
                // 文件上传
                // loading动画
                const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                })
                file.upload.then(
                    (response) => {
                        $timeout(() => {
                            if (!response.data.success) {
                                // 关闭loading
                                layer.close(importinglayer)
                                return logger.logError(response.data.message || '上传失败')
                            }
                            file.result = response.data
                            const { batchNo, sourceCount, errorCount, successKeyCount, reamrk } = file.result.value
                            const _req = {
                                pageNum: 1,
                                pageSize: 10,
                                param: batchNo,
                            }
                            // 请求错误信息
                            httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
                                // 关闭loading
                                layer.close(importinglayer)
                                // 获取导出信息详细数据
                                // const { sourceCount, endRow } = res.data.value;
                                const goodsImportRes = res.data.value
                                const modalData = {
                                    // 返回给弹窗的数据
                                    params: {
                                        batchNo,
                                        sourceCount,
                                        successCount: sourceCount - errorCount,
                                        errorCount,
                                        data: goodsImportRes,
                                        successKeyCount,
                                        reamrk,
                                    },
                                }
                                // 弹窗实例
                                const modalInstance = $uibModal.open({
                                    template: importModal,
                                    controller: 'importModalPreCtrl',
                                    backdrop: 'static',
                                    openedClass: 'mod-modal-importexcel mod-modal mod-modal-lg',
                                    windowClass: 'mod-modal mod-modal-lg',
                                    bindToController: true,
                                    resolve: {
                                        items1() {
                                            return modalData
                                        },
                                    },
                                })
                                // 弹窗回掉
                                modalInstance.result.then(
                                    (selectedItem) => {},
                                    () => {}
                                )
                            })
                        })
                    },
                    (response) => {
                        if (response.status > 0) {
                            // 关闭loading
                            layer.close(importinglayer)
                            logger.logError('上传失败 ')
                        }
                    },
                    (evt) => {
                        file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
                        console.log(file.progress)
                    }
                )
            }
        }
        function codeType(code) {
            let code_type = ''
            if (code == 'invoice_stock_alarm') {
                code_type = 'INVENTORY_WARNING'
            } else {
                code_type = 'EQUIPMENT_DROPS'
            }
            return code_type
        }
    }
}

preWarnListCtrl.$inject = ['$scope', '$location', 'logger', 'httpRequest', 'Upload', '$timeout', '$uibModal']
export default preWarnListCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/preWarn/preWarnListCtrl.js